<template>
  <v-container>
    <v-card style="margin-bottom:1em">
      <v-card-title> Automatic processes </v-card-title>
      <v-card-text>
        <v-btn @click="handleReloadRequest" :disabled="loading"><v-icon>mdi-refresh</v-icon> Reload</v-btn>
      </v-card-text>
    </v-card>
    <v-data-table
        :loading="loading" 
        :server-items-length="count"
        :items="items"
        :options.sync="tableOptions"
        :headers="tableHeaders"
        :footer-props="tableFooterProps"
        :item-class="() => 'automatic-processes-row'"
        @click:row="handleRowClick"
        >
      <template v-slot:item._status="{ item }">
        <ProcessExeuctionStatus :rc="item.rc" :signum="item.signum" />
      </template>
      <template v-slot:item._process="{ item }">
        <ProcessKlass :klass="item.process_klass" v-if="item.process_klass != null" />
        <span v-else style="font-family:monospace">{{ item.bin_path }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ProcessExeuctionStatus from '../../components/reports/process-execution-status';
import ProcessKlass from '../../components/reports/process-klass';

export default {
  name: "AutomaticProcessesPage",
  components: {
    ProcessExeuctionStatus,
    ProcessKlass
  },
  data() {
    return {
      count: 0,
      loading: true,
      items: [],
      tableOptions: null,
      tableHeaders: [
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'Process',
          value: '_process'
        },
        {
          text: 'Started',
          value: 'started_date'
        },
        {
          text: 'Finished',
          value: 'ended_date'
        },
        {
          text: 'Status',
          value: '_status'
        }
      ],
      tableFooterProps: {
        'items-per-page-options' : [10, 20, 50, 100]
      }
    };
  },
  created: async function() {
    await this.refreshCount();
  },
  watch: {
    tableOptions: {
      handler: function() {
        this.loadItemsFromOptions();
      },
      deep: true
    }
  },
  methods: {
    refreshCount: async function() {
      this.count = (await this.$http.get('/processexecutions/count')).data.count;
    },
    loadItems: async function(start, length) {
      const filter = {
        skip: start,
        limit: length,
        order: ['id DESC']
      };
      this.loading = true;
      try {
        const result = await this.$http.get('/processexecutions?filter=' + encodeURIComponent(JSON.stringify(filter)));
        this.items = result.data;
      }
      finally {
        this.loading = false;
      }
    },
    loadItemsFromOptions: async function() {
      const {page, itemsPerPage } = this.tableOptions;
      await this.loadItems((page - 1) * itemsPerPage, itemsPerPage);
    },
    handleRowClick: function(item) {
      this.$router.push(`/admin/automatic-processes/${item.id}`);
    },
    handleReloadRequest: async function() {
      this.items.splice(0, this.items.length);
      await this.refreshCount();
      this.tableOptions.page = 1;
      await this.loadItemsFromOptions();
    }
  },
};
</script>

<style>
.automatic-processes-row {
  cursor:pointer;
}
</style>